import React, { useMemo } from "react";
import { Link, useLocation } from "react-router-dom";
import { ImageElement } from "../UiElement";
import { getSideBarMenu } from "../../utils/common.util";
import adminRoutesMap from "../../routeControl/adminRoutes";

function AdminSidebar({ setActive, routeList, userData }) {
  const location = useLocation();

  const menu = useMemo(() => {
    let data = getSideBarMenu(routeList);
    const activeStatus = JSON.parse(sessionStorage.getItem("active_status"));

    if (userData?.type === "vendor" && activeStatus === false) {
      return data.filter((item) => item.path === adminRoutesMap.DASHBOARD.path);
    }

    return data;
  }, [routeList, userData]);

  const ToggleOverlay = () => {
    document.querySelector("body").classList.remove("openSidebar");
    setActive(false);
    document
      .querySelector(".adminHeader_click em")
      .classList.remove("tripon-close");
    document
      .querySelector(".adminHeader_click em")
      .classList.add("tripon-menu");
  };

  const getActiveMenu = (pathname) => {
    let path = location?.pathname;
    path =
      location?.pathname.includes("add-trip") ||
        location?.pathname.includes("edit-trip") ||
        location?.pathname.includes("trip-details")
        ? adminRoutesMap.ADDTRIPLIST.path
        : path;

    path = location?.pathname.includes("booking-details")
      ? adminRoutesMap.BOOKINGTRIPLIST.path
      : path;

    return path === pathname;
  };

  return (
    <>
      <aside className="sideBar">
        <div className="sideBar_logo">
          <Link to="/admin/dashboard" className="d-block text-center">
            <ImageElement isLightbox={false} source="logo-sidebar.svg" className="img-fluid" />
          </Link>
        </div>
        <div className="sideBar_list">
          {menu?.map((item, key) => {
            return (
              <div
                className={`sideBar_list_items ${getActiveMenu(item?.path) ? "active" : ""
                  }`}
                key={key}
              >
                <Link to={item?.path} className="sideBar_list_menu">
                  <em className={item?.icon} /> {item?.label}
                </Link>
              </div>
            );
          })}
        </div>
      </aside>
      <div className="sideOverlay" onClick={() => ToggleOverlay()} />
    </>
  );
}

export default AdminSidebar;
